import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecuperarSenhaRoutingModule } from './recuperar-senha-routing.module';
import { RecuperarSenhaComponent } from './recuperar-senha.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { FormsModule } from '@angular/forms';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        RecuperarSenhaRoutingModule,
        AppConfigModule,
        InputMaskModule,
        MessagesModule
    ],
    declarations: [RecuperarSenhaComponent]
})
export class RecuperarSenhaModule { }